// src/pages/Admin/PagesPersonnalisees/PagesPersonnalisees.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import usePagesPersonnalisees from "./hooks/usePagesPersonnalisees";

import PagesHero from "./components/PagesHero";
import PagesStats from "./components/PagesStats";
import PagesToolbar from "./components/PagesToolbar";
import PagesGrid from "./components/PagesGrid";
import PageDrawer from "./components/PageDrawer";
import PageDetails from "./components/PageDetails";
import PageForm from "./components/PageForm";
import ArticlesManager from "./components/ArticlesManager";

export default function PagesPersonnalisees() {
  useScrollToTop();

  const {
    loading,
    saving,
    articleSaving,
    filters,
    setFilter,
    pages,
    filteredPages,
    selectedPage,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = usePagesPersonnalisees();

  return (
    <div className="space-y-6">
      <PagesHero
        loading={loading}
        total={pages.length}
        activeCount={stats.active}
        articlesCount={stats.articles}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshPages}
      />

      <PagesStats loading={loading} stats={stats} />

      <PagesToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={pages.length}
        filteredCount={filteredPages.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshPages}
      />

      <PagesGrid
        loading={loading}
        pages={filteredPages}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onManageArticles={actions.openArticlesDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
        onToggleVisibility={actions.togglePageVisibility}
        onToggleMenuVisibility={actions.togglePageMenuVisibility}
      />

      <PageDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        page={selectedPage}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedPage && (
          <PageDetails
            page={selectedPage}
            onEdit={() => actions.openEditDrawer(selectedPage)}
            onManageArticles={() => actions.openArticlesDrawer(selectedPage)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <PageForm
            mode="create"
            saving={saving}
            onSubmit={actions.createPage}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedPage && (
          <PageForm
            mode="edit"
            page={selectedPage}
            saving={saving}
            onSubmit={actions.updatePage}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "articles" && selectedPage && (
          <ArticlesManager
            page={selectedPage}
            saving={articleSaving}
            onAddArticle={actions.addArticleToPage}
            onUpdateArticle={actions.updateArticleFromPage}
            onDeleteArticle={actions.deleteArticleFromPage}
            onClose={actions.closeDrawer}
          />
        )}
      </PageDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}